var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var findLastIndex = function (array, predicate) {
    if (!array.length) {
        return -1;
    }
    for (var i = array.length - 1; i >= 0; i -= 1) {
        if (predicate(array[i])) {
            return i;
        }
    }
    return -1;
};
export var range = function (length) {
    return new Array(length).fill(0).map(function (_, i) { return i; });
};
export var split = function (arr, index) { return [
    arr.slice(0, index),
    arr.slice(index),
]; };
/**
 * Creates a copy of an array, where all its elements are moved by the `shiftBy` offset in a wrapping manner.
 * @example
 * shifted([1, 2, 3, 4, 5, 6], 2)
 * > [5, 6, 1, 2, 3, 4]
 *
 * shifted([1, 2, 3, 4, 5, 6], -1)
 * > [2, 3, 4, 5, 6, 1]
 */
export var shifted = function (arr, shiftBy) {
    if (shiftBy === 0 || arr.length === 0) {
        return arr;
    }
    var splitIndex = shiftBy > 0
        ? arr.length - (shiftBy % arr.length)
        : (-1 * shiftBy) % arr.length;
    var _a = split(arr, splitIndex), front = _a[0], back = _a[1];
    return __spreadArray(__spreadArray([], back, true), front, true);
};
